import { COMPANY_BIOMETRIC_DEVICES_PATHS } from "@/routes/company/routes.biometric-devices";
import { COMPANY_DOCUMENTS_PATHS } from "@/routes/company/routes.documents";
import { COMPANY_EMPLOYEES_PATHS } from "@/routes/company/routes.employees";
import { COMPANY_EVENT_PATHS } from "@/routes/company/routes.events";
import { COMPANY_HELP_SUPPORT_PATHS } from "@/routes/company/routes.help-and-support";
import { COMPANY_LEAVES_MANAGEMENT_PATHS } from "@/routes/company/routes.leave-management";
import { COMPANY_MY_APP_PATHS } from "@/routes/company/routes.my-app";
import { COMPANY_TIME_ATTENDANCE_PATHS } from "@/routes/company/routes.time-attendance";
import { MS_COMPANY_POLICIES_PATHS } from "@/routes/my-space/routes.company-policies";
import { MS_DOCUMENTS_PATHS } from "@/routes/my-space/routes.documents";
import { MS_EVENT_PATHS } from "@/routes/my-space/routes.events";
import { MS_LEAVES_MANAGEMENT_PATHS } from "@/routes/my-space/routes.leave-management";
import { MS_TASKS_PATHS } from "@/routes/my-space/routes.tasks";
import { MS_TIME_ATTENDANCE_PATHS } from "@/routes/my-space/routes.time-attendance";
import type { TNotificationRoute } from "@/types/notifications.interface";

export const NOTIFICATION_ROUTE_MAP: Record<string, Record<string, TNotificationRoute>> = {
  MY_SPACE: {
    REGULARIZATION: {
      path: MS_TIME_ATTENDANCE_PATHS.VIEW_REGULARIZATION,
    },
    ATTENDANCE_EXCEPTION: {
      path: MS_TIME_ATTENDANCE_PATHS.VIEW_EXCEPTION,
    },
    TIME_ATTENDANCE: {
      path: MS_TIME_ATTENDANCE_PATHS.ATTENDANCE_SUMMARY,
    },
    // Manager digest ("N employees have not checked in"). Scoped to MY_SPACE so
    // it stays in the tab the manager already sees, but it links to the company
    // overview pre-filtered to today's absentees.
    ATTENDANCE_NO_CHECKIN: {
      path: COMPANY_TIME_ATTENDANCE_PATHS.OVERVIEW,
      query: { status: "absent" },
    },
    LEAVE_REQUEST: {
      path: MS_LEAVES_MANAGEMENT_PATHS.VIEW,
    },
    DOCUMENT_REQUEST: {
      path: MS_DOCUMENTS_PATHS.SENT_REQUEST_VIEW,
    },
    EVENT: {
      path: MS_EVENT_PATHS.VIEW,
    },
    COMPANY_POLICY: {
      path: MS_COMPANY_POLICIES_PATHS.VIEW,
    },
    // Task notifications carry only the task id; the resolver route maps it to
    // the canonical board-nested URL.
    TASK: {
      path: (id) => MS_TASKS_PATHS.TASK_REDIRECT(id),
    },
    // App-store review outcome → open the source app in the My Apps library.
    MY_APP: {
      path: (id) => COMPANY_MY_APP_PATHS.APP(id),
    },
  },
  COMPANY: {
    EMPLOYEES: {
      path: COMPANY_EMPLOYEES_PATHS.ONBOARDING,
      paramKey: "id",
    },
    REGULARIZATION: {
      path: COMPANY_TIME_ATTENDANCE_PATHS.VIEW_REGULARIZATION,
    },
    ATTENDANCE_EXCEPTION: {
      path: COMPANY_TIME_ATTENDANCE_PATHS.VIEW_EXCEPTION,
    },
    TIME_ATTENDANCE: {
      path: COMPANY_TIME_ATTENDANCE_PATHS.OVERVIEW,
    },
    LEAVE_REQUEST: {
      path: COMPANY_LEAVES_MANAGEMENT_PATHS.LEAVES_SUMMARY,
    },
    DOCUMENT_REQUEST: {
      path: COMPANY_DOCUMENTS_PATHS.SENT_REQUEST_VIEW,
    },
    EVENT: {
      path: COMPANY_EVENT_PATHS.VIEW,
    },
    HELP_SUPPORT: {
      path: COMPANY_HELP_SUPPORT_PATHS.VIEW,
    },
    // Biometric device alerts: an agent that stopped checking in, a terminal
    // that stopped answering or whose punches failed, and unmapped punches.
    BIOMETRIC_AGENT: {
      path: COMPANY_BIOMETRIC_DEVICES_PATHS.SETTINGS_VTAB_AGENTS,
    },
    BIOMETRIC_DEVICE: {
      path: (id) => COMPANY_BIOMETRIC_DEVICES_PATHS.DEVICE_EVENTS(String(id)),
    },
    BIOMETRIC_UNMAPPED_EVENTS: {
      path: COMPANY_BIOMETRIC_DEVICES_PATHS.UNMAPPED_EVENTS,
    },
  },
};
